// extracted by mini-css-extract-plugin
export var autoExpand = "_25-b";
export var container = "_25-a";
export var containerWidth = "_25-8";
export var disabled = "_25-2";
export var error = "_25-3";
export var fullWidth = "_25-9";
export var highlightContainer = "_25-5";
export var inputWrapper = "_25-0";
export var small = "_25-1";
export var textarea = "_25-4";
export var validatedTextarea = "_25-6";
export var visuallyHidden = "_25-7";